import type { DataAttribute } from '../../amplienceTypes/partials/exported/element-attributes-schema';
import type { ComponentType, ReactElement } from 'react';

import { useMatchesProfileToggle } from './ProfileToggleContext';

type DataAttributesGetter<Props> = (props: Props) => DataAttribute[] | undefined;

export const withProfileToggle = <Props extends object>(
  Component: ComponentType<Props>,
  getDataAttributes: DataAttributesGetter<Props>
): ((props: Props) => ReactElement) => {
  const WithProfileToggle = (props: Props): ReactElement => {
    const shouldShowComponent = useMatchesProfileToggle(getDataAttributes(props));

    if (!shouldShowComponent) {
      return <></>;
    }

    return <Component {...props} />;
  };

  const componentName = Component.displayName || Component.name || 'Component';

  WithProfileToggle.displayName = `withProfileToggle(${componentName})`;

  return WithProfileToggle;
};
